// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
// Components, Layouts, Pages
import { BaseToolbar } from '~/components/common';
import PageShell from '~/pages/common/pageShell/PageShell';
// Others
// Styles, images, icons
import styles from './Category.module.scss';

const cx = classNames.bind(styles);

const Category = () => {
  //#region Destructuring Props
  const { t } = useTranslation(['admin/category']);
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <PageShell title={t('category_title')}>
    <Box component={'div'} id='categoryPage' className={cx('container')}>
      <BaseToolbar />

      <Box component={'div'} className={cx('body')}></Box>
    </Box>
    </PageShell>
  );
};

export default Category;
